import { Routes, Route, useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { scrollToAnchorAfterLayout } from './utils/scrollToAnchor';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServicesOverviewPage from './pages/ServicesOverviewPage';
import ScientificConsultingPage from './pages/ScientificConsultingPage';
import MentorshipPage from './pages/MentorshipPage';
import WorkforceDevelopmentPage from './pages/WorkforceDevelopmentPage';
import PartnershipsPage from './pages/PartnershipsPage';
import ImpactPage from './pages/ImpactPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import { company, navItems } from './data/siteData';
import { initAnalytics, trackPageview } from './analytics';

const VALID_HASH_IDS = /^[a-zA-Z][a-zA-Z0-9_-]*$/;

function ScrollToTop() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      if (VALID_HASH_IDS.test(id)) {
        const target = document.getElementById(id);
        if (target) {
          scrollToAnchorAfterLayout(target);
          return;
        }
      }
    }

    window.scrollTo(0, 0);
  }, [hash, pathname]);

  return null;
}

function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageview(pathname + search, document.title);
  }, [pathname, search]);

  return null;
}

function NotFoundPage() {
  return (
    <section className="section shell" style={{ textAlign: 'center', minHeight: '50vh', display: 'grid', placeItems: 'center' }}>
      <div>
        <h1>Page Not Found</h1>
        <p className="lead">The page you're looking for doesn't exist.</p>
        <div className="button-row" style={{ justifyContent: 'center', marginTop: '1.5rem' }}>
          <Link to="/" className="button button--primary">Return Home</Link>
        </div>
      </div>
    </section>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="site-shell">
      <ScrollToTop />
      <AnalyticsTracker />
      <Navbar items={navItems} ctaLabel={company.primaryCta} />
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/programs" element={<ServicesPage />} />
          <Route path="/services" element={<ServicesOverviewPage />} />
          <Route path="/services/scientific-consulting" element={<ScientificConsultingPage />} />
          <Route path="/services/stem-workforce" element={<WorkforceDevelopmentPage />} />
          <Route path="/services/mentorship" element={<MentorshipPage />} />
          {/* Backward-compat: /workforce-development continues to render the same page */}
          <Route path="/workforce-development" element={<WorkforceDevelopmentPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </ErrorBoundary>
      <Footer items={navItems} />
    </div>
  );
}
